import { type ActivityItem, type Contributor } from '@atlassian/recent-work-client';

import {
	type Activity,
	type ActivityObject,
	type UserActivityEntry,
} from '../../models/ActivityObject';
import { replaceHypensToSpace, replaceUnderscoresToSpace, toTitleCase } from '../../utils/string';

function getDirectContainer(node: ActivityItem): string {
	let container = '';
	const len = node.containers?.length || 0;
	if (node.containers && len > 0) {
		container = node.containers[len - 1].name;
	}

	const provider = toTitleCase(
		replaceUnderscoresToSpace(replaceHypensToSpace(node.object.product.toLowerCase())),
	);

	return container || provider; // fallback is product name
}

function transformContributorToActivity(
	contributor: Contributor,
	type = '',
	date: string | null = null,
): UserActivityEntry {
	return {
		date,
		user: {
			id: contributor.accountId,
			fullName: contributor.name,
		},
		type,
	};
}

function transformNodeToWorkLensActivityObject(node: ActivityItem): ActivityObject {
	const { name = '', url = '', icon = null, product = '' } = node.object || {};

	return {
		name: name || '',
		url,
		cloudId: '',
		iconUrl: icon ? icon.value : '',
		provider: product,
		container: getDirectContainer(node),
	};
}

function transformContributersForActor({
	actor,
	contributors,
	eventType,
	timestamp,
}: ActivityItem): UserActivityEntry[] {
	const updatedContributors = !contributors.length && actor ? [actor] : contributors;
	return updatedContributors.map((contributor: Contributor) =>
		transformContributorToActivity(contributor, eventType, timestamp),
	);
}

export function transformDataFromRecentWorkClient(nodes: ActivityItem[]): Activity[] {
	return nodes.map((node: ActivityItem) => {
		const {
			object: { id: objectId },
			timestamp,
		} = node;

		return {
			objectId,
			lastModification: timestamp,
			activity: transformContributersForActor(node),
			object: {
				...transformNodeToWorkLensActivityObject(node),
			},
		};
	});
}
